import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
 
@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  constructor() {}
  SetSession(user: any): void {
    const userStr = JSON.stringify(user);
    const expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + 24 * 60 * 60 * 1000); // 1 gün
    document.cookie = `${environment.apiLocations.cookieName}=${userStr};expires=${expirationDate.toUTCString()};path=/;secure;domain=.amatis.dev;secure;SameSite=Strict`;
  }
 
 
GetSession(): any {
    if (typeof document !== 'undefined') {
      const name = `${environment.apiLocations.cookieName}=`;
      const decodedCookie = decodeURIComponent(document.cookie);
      const cookies = decodedCookie.split(';');
 
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(name) === 0) {
          return JSON.parse(cookie.substring(name.length, cookie.length));
        }
      }
    }
 
    return null;
  }
 
  ClearSession(): void {
    if (typeof document !== 'undefined') {
      document.cookie = `${environment.apiLocations.cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;secure;SameSite=Lax`;
    }
  }
 
  TerminateSession(): void {
    this.ClearSession();
  }
}